import EmberRouter from '@ember/routing/router';
import config from 'bullitt-time-results/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function() 
{
    this.route('events');
    this.route('event', { path: '/events/:event_id' }, function()
    {
		this.route('details');
		this.route('classgroup', { path: '/classgroup/:classGroup_id' }, function()
		{
			this.route('details');
		});
		this.route('fis',function()
		{
			this.route('penalties');
			this.route('points');
		});
		this.route('vtyc',function()
		{
			this.route('points');
		});
		this.route('mpa',function()
		{
			this.route('points');
		});
		this.route('vpa',function()
		{
			this.route('points');
			this.route('pointsCombined');
		});
		this.route('miaa',function()
		{
			this.route('points');
		});
		this.route('jns',function()
		{
			this.route('points');
			this.route('alaskaCupPoints');
			this.route('rogerWestonPoints');
			this.route('clubPoints');
		});
		this.route('results',function()
		{
			this.route('individuals');
			this.route('individualsCombined');
			this.route('teams');
			this.route('sprint');
		});
	});
	this.route('cachecontrol');
});
